"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerDueDiligenceConductItem = void 0;
const Field_type_1 = require("../../../types/Field.type");
const CustomerDueDiligenceCriteria_1 = require("../../enm/CustomerDueDiligenceCriteria");
exports.CustomerDueDiligenceConductItem = {
    priority: 1,
    label: 'fields.enm.customer_due_diligence_criteria.label',
    fallbackLabel: 'Which of the following information does your entity gather, verify and retain on the merchant when conducting CDD?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.Enum,
    options: CustomerDueDiligenceCriteria_1.CustomerDueDiligenceCriteriaRef.options,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
